import type { MerchantUserRole } from '../api/types';

export type NavId =
  | 'dashboard'
  | 'kyb'
  | 'settlement'
  | 'payouts'
  | 'developer'
  | 'disputes'
  | 'team'
  | 'terminals'
  | 'security';

const ROLE_NAV: Record<MerchantUserRole, NavId[]> = {
  owner: ['dashboard', 'kyb', 'settlement', 'payouts', 'developer', 'terminals', 'disputes', 'team', 'security'],
  developer: ['developer', 'security'],
  finance: ['dashboard', 'payouts', 'disputes'],
};

export function navItemsForRole(role: MerchantUserRole): NavId[] {
  return ROLE_NAV[role];
}

export function canAccess(role: MerchantUserRole, nav: NavId): boolean {
  return ROLE_NAV[role].includes(nav);
}
